export { default as Footer } from "ui/Footer/Footer";
